import { FSMPlan } from 'containers/integrations/fsm-integration/constants';
import { FSM_ENDED_MODAL_ROUTES, FSM_FREE_PLAN_ROUTES, FSM_UPGRADE_NEEDED_ROUTES } from './constants';
import { store } from 'store/store';
import useFSMPlanInfo from 'containers/integrations/fsm-integration/hooks/useFSMPlanInfo';

export const shouldShowFSMModal = (pathname: string) => {
  const { rootReducer } = store.getState();
  const { showFSMModal } = rootReducer.modal;
  const { currentFSMPlan, isSystemDowngraded, hasDowngradedAfterTrial } = useFSMPlanInfo();

  const isFSMSubscriptionNeeded = FSM_FREE_PLAN_ROUTES.some(route => pathname.includes(route));

  const isUpgradeNeeded = FSM_UPGRADE_NEEDED_ROUTES.some(route => pathname.includes(route));

  const showFSMEndedModal = FSM_ENDED_MODAL_ROUTES.some(route => pathname.includes(route));

  if (currentFSMPlan === FSMPlan.NO_PLAN) {
    return (isFSMSubscriptionNeeded || isUpgradeNeeded) && showFSMModal;
  }

  if (currentFSMPlan === FSMPlan.FREE && (isSystemDowngraded || hasDowngradedAfterTrial)) {
    return showFSMEndedModal && showFSMModal;
  }

  if (currentFSMPlan === FSMPlan.FREE) {
    return isUpgradeNeeded && showFSMModal;
  }

  return false;
};
